// TablaSolicitudes.js — Merge Solponiente + SectorBXII
import { useState, useEffect } from "react";
import { Table, Button, Form, Modal, Badge } from "react-bootstrap";
import FirmaElectronica from "../FirmaElectronica";

const TablaSolicitudes = () => {
  const [solicitudes, setSolicitudes] = useState([]);
  const [selectores, setSelectores] = useState({});
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [solicitudAEliminar, setSolicitudAEliminar] = useState(null);
  const userRol = localStorage.getItem("rol");

  const getHeaders = () => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  });

  useEffect(() => {
    const fetchSolicitudes = async () => {
      try {
        const response = await fetch(
          "https://oficinavirtual-solponiente.com/api/solicitudes/completas",
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        if (response.ok) {
          const data = await response.json();
          setSolicitudes(data);
        } else {
          console.error("Error al obtener solicitudes");
        }
      } catch (error) {
        console.error("Error al hacer la solicitud:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSolicitudes();
  }, []);

  const handleDownload = (base64Data, fileName) => {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      byteArrays.push(new Uint8Array(byteNumbers));
    }
    const blob = new Blob(byteArrays, { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const actualizarEstado = async (id, nuevoEstado) => {
    try {
      const response = await fetch(
        `https://oficinavirtual-solponiente.com/api/solicitudes/${id}`,
        {
          method: "PUT",
          headers: getHeaders(),
          body: JSON.stringify({ Estado: nuevoEstado }),
        }
      );
      if (response.ok) {
        const data = await response.json();
        setSolicitudes((prev) =>
          prev.map((s) =>
            s.SolicitudID === id ? { ...s, Estado: data.Estado } : s
          )
        );
      } else {
        console.error("Error al actualizar el estado");
      }
    } catch (error) {
      console.error("Error en la solicitud PUT:", error);
    }
  };

  const handleDelete = (id) => {
    setSolicitudAEliminar(id);
    setShowModal(true);
  };

  const confirmDelete = async () => {
    try {
      const response = await fetch(
        `https://oficinavirtual-solponiente.com/api/solicitudes/${solicitudAEliminar}`,
        {
          method: "DELETE",
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      if (response.ok) {
        setSolicitudes((prev) =>
          prev.filter((s) => s.SolicitudID !== solicitudAEliminar)
        );
        setShowModal(false);
        alert("Solicitud eliminada con éxito.");
      } else {
        console.error("Error al eliminar la solicitud");
      }
    } catch (error) {
      console.error("Error al eliminar:", error);
    }
  };

  const cancelarDelete = () => {
    setShowModal(false);
    setSolicitudAEliminar(null);
  };

  const activarSelector = (id) =>
    setSelectores({ ...selectores, [id]: true });
  const desactivarSelector = (id) =>
    setSelectores({ ...selectores, [id]: false });

  const renderEstado = (estado) => {
    const colores = {
      pendiente: "warning",
      "en proceso": "primary",
      completada: "success",
      rechazada: "danger",
    };
    return (
      <Badge bg={colores[estado] || "secondary"} className="text-capitalize">
        {estado}
      </Badge>
    );
  };

  if (loading) return <p className="mt-3">Cargando solicitudes...</p>;

  return (
    <div className="mt-4">
      <div className="table-responsive">
        <Table hover className="rounded-3 shadow-sm">
          <thead className="bg-primary text-white">
            <tr>
              <th>Usuario</th>
              <th>Descripción</th>
              <th>Fecha de solicitud</th>
              <th>Archivo adjunto</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {solicitudes.map((s) => (
              <tr key={s.SolicitudID}>
                <td>
                  {s.Usuario.Nombre} {s.Usuario.Apellidos}
                </td>
                <td>{s.Descripcion}</td>
                <td>{new Date(s.FechaSolicitud).toLocaleDateString("es-ES")}</td>
                <td>
                  <div className="small text-muted">{s.NombreDocumento}</div>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    className="mt-1"
                    onClick={() => handleDownload(s.Documentos, s.NombreDocumento)}
                  >
                    <i className="bi bi-download"></i> Descargar
                  </Button>
                </td>
                <td>
                  {selectores[s.SolicitudID] ? (
                    <Form.Select
                      size="sm"
                      value={s.Estado}
                      onChange={(e) =>
                        actualizarEstado(s.SolicitudID, e.target.value)
                      }
                    >
                      <option value="pendiente">Pendiente</option>
                      <option value="en proceso">En proceso</option>
                      <option value="completada">Completada</option>
                      <option value="rechazada">Rechazada</option>
                    </Form.Select>
                  ) : (
                    renderEstado(s.Estado)
                  )}
                </td>
                <td>
                  <div className="d-flex flex-column gap-1">
                    {/* Botón firma */}
                    {(userRol === "admin" && !s.FirmadoAdmin) ||
                    (userRol === "usuario" && !s.FirmadoUser) ? (
                      <FirmaElectronica
                        documento={s.Documentos}
                        documentoId={s.DocumentoID}
                        solicitudId={s.SolicitudID}
                      />
                    ) : (
                      <Button variant="primary" size="sm" disabled>
                        <i className="bi bi-check-lg"></i> Firmado
                      </Button>
                    )}

                    {/* Botón cambiar estado */}
                    {!selectores[s.SolicitudID] ? (
                      <Button
                        variant="warning"
                        size="sm"
                        onClick={() => activarSelector(s.SolicitudID)}
                      >
                        <i className="bi bi-pencil"></i> Cambiar Estado
                      </Button>
                    ) : (
                      <Button
                        variant="warning"
                        size="sm"
                        onClick={() => {
                          actualizarEstado(s.SolicitudID, s.Estado);
                          desactivarSelector(s.SolicitudID);
                        }}
                      >
                        <i className="bi bi-check-lg"></i> Aceptar
                      </Button>
                    )}

                    {/* Botón eliminar */}
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => handleDelete(s.SolicitudID)}
                    >
                      <i className="bi bi-trash"></i> Eliminar
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {/* Modal confirmación eliminar */}
      <Modal show={showModal} onHide={cancelarDelete} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Estás seguro de que deseas eliminar esta solicitud? Esta acción no se
          puede deshacer.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelarDelete}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Eliminar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TablaSolicitudes;
